export function splitChunks<T>(arr: T[], chunks: number): T[][] {
  if (arr.length > chunks) {
    return [arr.slice(0, chunks)].concat(
      splitChunks(arr.slice(chunks), chunks),
    );
  }
  return [arr];
}
